'use es6'; // /* eslint-disable no-unused-vars */

import { PREVIEW_OPTIONS_FETCH, LAYOUT_DELETE, CUSTOM_WIDGET_BUFFER_DELETE, TEMPLATE_BUFFER_DELETE } from 'DesignData/actions/ActionTypes';
import { save, del } from 'DesignData/actions/PreviewOptions';
let currentOptions = null;
export default (({
  dispatch,
  getState
}) => next => action => {
  const result = next(action);
  /*
   * Autosave changes
   */

  const state = getState();
  const {
    previewOptions
  } = state;

  if (currentOptions === null) {
    // This will occur when redux starts and gets the default state from the reducer.
    currentOptions = previewOptions;
  } else if (currentOptions !== previewOptions && result.type !== PREVIEW_OPTIONS_FETCH) {
    // You __must__ dispatch the save *after* updating the `currentOptions` reference
    // otherwise you'll have an infinite loop.
    currentOptions = previewOptions;
    dispatch(save());
  }
  /*
   * Delete options when respective asset is deleted.
   */


  switch (result.type) {
    case LAYOUT_DELETE:
      {
        const {
          layoutId,
          deleted
        } = result;
        if (deleted) dispatch(del(layoutId));
        break;
      }

    case CUSTOM_WIDGET_BUFFER_DELETE:
      {
        const {
          error,
          customWidgetId
        } = result;
        if (!error) dispatch(del(customWidgetId));
        break;
      }

    case TEMPLATE_BUFFER_DELETE:
      {
        const {
          error,
          templateId
        } = result;
        if (!error) dispatch(del(templateId));
        break;
      }

    default:
      break;
  }

  return result;
});